@import "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap";

/* src/app/forms/formula-lab/formula-lab.component.scss */
:host {
  display: block;
  height: 100%;
  --bg: #0f172a;
  --panel: #1e293b;
  --panel-2: #172033;
  --elev: #243049;
  --border: #334155;
  --border-soft: #1f2a3d;
  --fg: #f8fafc;
  --muted: #94a3b8;
  --accent: #22c55e;
  --accent-press: #16a34a;
  --danger: #ef4444;
  --mono:
    "Fira Code",
    "JetBrains Mono",
    Consolas,
    monospace;
  font-family:
    "Plus Jakarta Sans",
    system-ui,
    sans-serif;
}
.lab {
  height: 100%;
  min-height: 86vh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
  color: var(--fg);
  overflow: hidden;
}
.lab-top {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 18px;
  background:
    linear-gradient(
      180deg,
      #1b2740,
      var(--panel));
  border-bottom: 1px solid var(--border);
}
.lab-brand {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.2px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.lab-brand i {
  color: var(--accent);
  filter: drop-shadow(0 0 8px rgba(34, 197, 94, 0.5));
}
.lab-top-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
}
.lab-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 0;
  color: var(--muted);
  font: inherit;
  font-size: 12.5px;
  cursor: pointer;
  padding: 4px;
}
.lab-knob {
  width: 34px;
  height: 18px;
  border-radius: 10px;
  background: var(--elev);
  position: relative;
  transition: background 0.2s ease;
  flex: 0 0 auto;
}
.lab-knob::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #64748b;
  transition: transform 0.2s ease, background 0.2s ease;
}
.lab-switch.on {
  color: var(--fg);
}
.lab-switch.on .lab-knob {
  background: rgba(34, 197, 94, 0.35);
}
.lab-switch.on .lab-knob::after {
  transform: translateX(16px);
  background: var(--accent);
}
.lab-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.18s ease;
  white-space: nowrap;
}
.lab-btn:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}
.lab-btn-run {
  background: var(--accent);
  color: #052e16;
  border-color: var(--accent);
}
.lab-btn-run:hover {
  background: #2ee36a;
  box-shadow: 0 0 14px rgba(34, 197, 94, 0.35);
}
.lab-btn-run:disabled {
  opacity: 0.6;
  cursor: default;
  box-shadow: none;
}
.lab-btn-ghost {
  background: transparent;
  color: var(--fg);
  border-color: var(--border);
}
.lab-btn-ghost:hover {
  background: var(--elev);
  border-color: #4b5b76;
}
.lab-btn.sm {
  padding: 5px 10px;
  font-size: 12px;
}
.lab-btn-mini {
  padding: 3px 9px;
  font-size: 11.5px;
  background: transparent;
  color: var(--accent);
  border-color: var(--border);
}
.lab-btn-mini:hover {
  background: var(--elev);
}
.lab-body {
  flex: 1 1 auto;
  display: flex;
  min-height: 0;
}
.lab-explorer {
  flex: 0 0 272px;
  display: flex;
  flex-direction: column;
  background: var(--panel-2);
  border-right: 1px solid var(--border);
  min-height: 0;
}
.lab-main {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  padding: 14px 16px;
  gap: 14px;
  overflow-y: auto;
  min-width: 0;
}
.lab-result {
  flex: 0 0 34%;
  max-width: 520px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px 16px;
  background: var(--panel-2);
  border-left: 1px solid var(--border);
  min-height: 0;
}
.lab-panel-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--muted);
  display: flex;
  align-items: center;
  gap: 7px;
}
.lab-panel-label i {
  color: var(--accent);
}
.lab-panel-label.between {
  justify-content: space-between;
}
.lab-search {
  position: relative;
  padding: 12px 12px 8px;
}
.lab-search i {
  position: absolute;
  left: 22px;
  top: 21px;
  color: var(--muted);
  font-size: 13px;
}
.lab-search input {
  width: 100%;
  background: var(--bg);
  border: 1px solid var(--border);
  color: var(--fg);
  border-radius: 8px;
  padding: 8px 10px 8px 30px;
  font: inherit;
  font-size: 13px;
  transition: border-color 0.18s ease;
}
.lab-search input::placeholder {
  color: #64748b;
}
.lab-search input:focus {
  outline: none;
  border-color: var(--accent);
}
.lab-cats {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 0 6px 12px;
}
.lab-cat-head {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 0;
  color: var(--fg);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 8px;
  border-radius: 7px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.lab-cat-head:hover {
  background: var(--panel);
}
.lab-caret {
  font-size: 10px;
  color: var(--muted);
}
.lab-cat-ic {
  color: var(--accent);
  font-size: 13px;
}
.lab-cat-label {
  flex: 1 1 auto;
  text-align: left;
}
.lab-cat-count {
  background: var(--elev);
  color: var(--muted);
  border-radius: 9px;
  padding: 0 8px;
  font-size: 11px;
  line-height: 18px;
}
.lab-fn {
  padding: 6px 10px 7px 26px;
  cursor: pointer;
  border-left: 2px solid transparent;
  border-radius: 0 6px 6px 0;
}
.lab-fn:hover {
  background: var(--panel);
}
.lab-fn.sel {
  background: rgba(34, 197, 94, 0.1);
  border-left-color: var(--accent);
}
.lab-fn-line {
  display: flex;
  align-items: center;
}
.lab-fn-name {
  font-family: var(--mono);
  font-size: 12.5px;
  color: #cfe9ff;
}
.lab-fn-add {
  margin-left: auto;
  background: transparent;
  border: 0;
  color: var(--accent);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease;
}
.lab-fn:hover .lab-fn-add {
  opacity: 1;
}
.lab-fn-desc {
  font-size: 11px;
  color: var(--muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lab-ace {
  flex: 0 0 auto;
  width: 100%;
  min-height: 200px;
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
}
.lab-sub {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.lab-vars {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.lab-var {
  display: flex;
  align-items: center;
  gap: 7px;
}
.lab-in {
  background: var(--bg);
  border: 1px solid var(--border);
  color: var(--fg);
  border-radius: 7px;
  padding: 6px 9px;
  font: inherit;
  font-size: 12.5px;
  transition: border-color 0.18s ease;
}
.lab-in:focus {
  outline: none;
  border-color: var(--accent);
}
.lab-in.key {
  flex: 0 0 34%;
  font-family: var(--mono);
}
.lab-in.val {
  flex: 1 1 auto;
  min-width: 0;
}
.lab-in.type {
  flex: 0 0 96px;
  cursor: pointer;
}
.lab-in.type option {
  background: var(--panel);
}
.lab-x {
  background: transparent;
  border: 0;
  color: var(--muted);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: color 0.15s ease, background 0.15s ease;
}
.lab-x:hover {
  color: var(--fg);
  background: var(--elev);
}
.lab-x.danger:hover {
  color: var(--danger);
}
.lab-examples {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.lab-chip {
  background: var(--panel);
  border: 1px solid var(--border);
  color: var(--fg);
  border-radius: 16px;
  padding: 4px 12px;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.18s ease;
}
.lab-chip:hover {
  border-color: var(--accent);
  color: var(--accent);
}
.lab-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  text-transform: none;
}
.lab-pill {
  font-size: 10.5px;
  font-weight: 700;
  padding: 1px 8px;
  border-radius: 10px;
  text-transform: uppercase;
}
.lab-pill.ok {
  background: rgba(34, 197, 94, 0.15);
  color: var(--accent);
}
.lab-pill.err {
  background: rgba(239, 68, 68, 0.15);
  color: #fca5a5;
}
.lab-pill.type {
  background: var(--elev);
  color: var(--muted);
}
.lab-ms {
  font-size: 11px;
  color: var(--muted);
}
.lab-console {
  flex: 1 1 auto;
  min-height: 160px;
  overflow: auto;
  background: #0a0f1e;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 14px 16px;
  transition: opacity 0.15s ease;
}
.lab-console.loading {
  opacity: 0.5;
}
.lab-out {
  margin: 0;
  font-family: var(--mono);
  font-size: 13px;
  color: #8ce0a6;
  white-space: pre-wrap;
  word-break: break-word;
}
.lab-err {
  font-family: var(--mono);
  font-size: 12.5px;
  color: #fca5a5;
  white-space: pre-wrap;
}
.lab-placeholder {
  color: #5b6b86;
  font-size: 13px;
}
.lab-placeholder b {
  color: var(--accent);
}
.lab-doc {
  flex: 0 0 auto;
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.lab-doc-title {
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 7px;
}
.lab-doc-title i {
  color: var(--accent);
}
.lab-ret {
  margin-left: auto;
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  background: var(--elev);
  color: var(--muted);
  padding: 1px 8px;
  border-radius: 10px;
}
.lab-doc-desc {
  font-size: 12.5px;
  color: #cbd5e1;
}
.lab-doc-sig {
  display: block;
  background: var(--bg);
  border: 1px solid var(--border-soft);
  border-radius: 6px;
  padding: 6px 9px;
  font-family: var(--mono);
  font-size: 12.5px;
  color: #cfe9ff;
  white-space: pre-wrap;
  word-break: break-word;
}
.lab-doc-sig.ex {
  color: #8ce0a6;
}
.lab-ex-lab {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--muted);
  display: flex;
  align-items: center;
  gap: 8px;
}
.lab-ex-res {
  font-family: var(--mono);
  color: var(--accent);
  background: rgba(34, 197, 94, 0.12);
  border-radius: 4px;
  padding: 0 6px;
  text-transform: none;
}
.lab-ex-tpl {
  color: #fbbf24;
  background: rgba(251, 191, 36, 0.12);
  border-radius: 4px;
  padding: 0 6px;
  text-transform: none;
}
.lab-doc-combina {
  font-size: 11.5px;
  color: var(--muted);
  font-style: italic;
}
.lab-doc-actions {
  display: flex;
  gap: 8px;
  margin-top: 2px;
}
.lab-empty {
  color: var(--muted);
  font-size: 12.5px;
  padding: 10px;
}
.lab-empty.small {
  padding: 0;
}
.lab-empty code {
  background: var(--elev);
  padding: 0 5px;
  border-radius: 4px;
  font-family: var(--mono);
}
.lab-mode-badge {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  background: rgba(34, 197, 94, 0.15);
  color: var(--accent);
  border-radius: 6px;
  padding: 1px 7px;
  margin-left: 6px;
}
.lab-code-hint {
  background: rgba(34, 197, 94, 0.07);
  border: 1px solid rgba(34, 197, 94, 0.18);
  border-radius: 8px;
  padding: 9px 13px;
  font-size: 12px;
  color: var(--muted);
  line-height: 1.55;
  display: flex;
  gap: 9px;
  align-items: flex-start;
}
.lab-code-hint i {
  color: var(--accent);
  flex: 0 0 auto;
  margin-top: 2px;
}
.lab-code-hint code {
  background: var(--elev);
  padding: 0 5px;
  border-radius: 4px;
  font-family: var(--mono);
  font-size: 11.5px;
  color: var(--fg);
}
.lab-trace {
  flex: 0 0 auto;
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  max-height: 220px;
  overflow-y: auto;
}
.lab-trace-item {
  display: grid;
  grid-template-columns: 26px 1fr auto auto auto;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  font-size: 11.5px;
  font-family: var(--mono);
  border-bottom: 1px solid var(--border-soft);
}
.lab-trace-item:last-child {
  border-bottom: 0;
}
.lab-trace-item.err {
  background: rgba(239, 68, 68, 0.06);
}
.lab-trace-item.setvar {
  background: rgba(34, 197, 94, 0.04);
}
.lab-trace-line {
  color: #4b5b76;
  text-align: right;
  font-size: 10.5px;
  font-weight: 700;
}
.lab-trace-formula {
  color: #9db4cc;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.lab-trace-arrow {
  color: var(--accent);
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  font-family: inherit;
}
.lab-trace-result {
  color: #8ce0a6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}
.lab-trace-error {
  color: #fca5a5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}
.lab-trace-ms {
  color: #4b5b76;
  font-size: 10px;
  white-space: nowrap;
  text-align: right;
}
@media (max-width: 1100px) {
  .lab-body {
    flex-direction: column;
    overflow-y: auto;
  }
  .lab-explorer {
    flex: 0 0 auto;
    max-height: 260px;
    border-right: 0;
    border-bottom: 1px solid var(--border);
  }
  .lab-result {
    flex: 0 0 auto;
    max-width: none;
    border-left: 0;
    border-top: 1px solid var(--border);
  }
}
@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
  }
}
.lab-icon-btn {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--muted);
  width: 32px;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.18s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.lab-icon-btn:hover {
  color: var(--accent);
  border-color: var(--accent);
}
.lab-icon-btn:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}
.lab.light {
  --bg: #ffffff;
  --panel: #f8fafc;
  --panel-2: #f1f5f9;
  --elev: #e2e8f0;
  --border: #d8dee9;
  --border-soft: #e8edf3;
  --fg: #0f172a;
  --muted: #64748b;
  --accent: #16a34a;
  --accent-press: #15803d;
}
.lab.light .lab-top {
  background:
    linear-gradient(
      180deg,
      #ffffff,
      var(--panel));
}
.lab.light .lab-brand i {
  filter: none;
}
.lab.light .lab-fn-name {
  color: #1d4ed8;
}
.lab.light .lab-console {
  background: #f8fafc;
}
.lab.light .lab-out {
  color: #15803d;
}
.lab.light .lab-err {
  color: #b91c1c;
}
.lab.light .lab-placeholder {
  color: #94a3b8;
}
.lab.light .lab-doc-desc {
  color: #475569;
}
.lab.light .lab-doc-sig {
  color: #1d4ed8;
}
.lab.light .lab-doc-sig.ex {
  color: #15803d;
}
.lab.light .lab-pill.err {
  color: #b91c1c;
}
.lab.light .lab-knob::after {
  background: #94a3b8;
}
.lab.light .lab-trace {
  background: #fff;
}
.lab.light .lab-trace-formula {
  color: #475569;
}
.lab.light .lab-trace-result {
  color: #15803d;
}
.lab.light .lab-code-hint {
  background: rgba(22, 163, 74, 0.06);
  border-color: rgba(22, 163, 74, 0.18);
}
.lab-nota {
  padding: 10px 12px;
  border-radius: 6px;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.35);
  color: #93c5fd;
  font-size: 13px;
  line-height: 1.5;
}
.lab.light .lab-nota {
  color: #1e40af;
  background: rgba(59, 130, 246, 0.07);
}
.lab-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 16px;
  border-top: 1px solid rgba(148, 163, 184, 0.25);
  background: rgba(15, 23, 42, 0.35);
}
.lab.light .lab-dialog-footer {
  background: rgba(241, 245, 249, 0.6);
  border-top-color: rgba(100, 116, 139, 0.25);
}
/*# sourceMappingURL=formula-lab.component.css.map */
